"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuestionsAndAnswers = void 0;
var getQuestionsAndAnswers_1 = __importDefault(require("./getQuestionsAndAnswers"));
exports.getQuestionsAndAnswers = getQuestionsAndAnswers_1.default;
